import { FC } from 'react';

export const RewardText: FC<React.PropsWithChildren<{ text: string }>> = () => null;
